let _singleton = Symbol();

class CoordinateHelper {
  constructor(singletonToken) {
    if (_singleton !== singletonToken)
      throw new Error('Cannot instantiate directly.');

    this.coordinateComponents = [];
  }

  static get instance() {
    if (!this[_singleton]) this[_singleton] = new CoordinateHelper(_singleton);

    return this[_singleton];
  }

  registerComponent(component) {
    this.coordinateComponents.push(component);
  }

  unRegisterComponent(component) {
    this.coordinateComponents = this.coordinateComponents.filter(
      (c) => c != component,
    );
  }

  setCoordinates(coordinates) {
    this.coordinateComponents.forEach((component) => {
      component.setCoordinates(coordinates);
    });
  }
}

export default CoordinateHelper;
